import { render, staticRenderFns } from "./contacto.vue?vue&type=template&id=3ae675d5&scoped=true&"
import script from "./contacto.vue?vue&type=script&lang=js&"
export * from "./contacto.vue?vue&type=script&lang=js&"
import style0 from "./contacto.vue?vue&type=style&index=0&id=3ae675d5&scoped=true&lang=css&"
import style1 from "./contacto.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae675d5",
  null
  
)

export default component.exports